<mat-progress-bar mode="indeterminate" *ngIf="globalLoaderAsync === true"></mat-progress-bar>

<styles-card-top-bar
  imageUrl="../assets/full-logo-white.svg"
  [menuToggle]="$any(sideNav)"
  (menuToggled)="sideNavToggle($any($event))"
  [ngClass]="authService.authenticated() ? '' : 'topbar-logged-out'"
>
  <ng-container profilePic>
    <framework-person-image [personId]="$any(authService).profileId" size="30px" routerLink="/my/overview">
    </framework-person-image
  ></ng-container>
  <ng-container bf-topbar-notifications>
    <div class="lightMode search">
      <framework-search-feeds
        [resetOnSelected]="true"
        placeholder="Search for orgs"
        (chosenFeed)="jumpToOrg($any($event))"
        *ngIf="!enabledBetaSearch"
      >
      </framework-search-feeds>

      <search-autocomplete *ngIf="enabledBetaSearch" placeholder="Search"></search-autocomplete>
    </div>
    <div class="clickable beta-search" *ngIf="!enabledBetaSearch" (click)="enabledBetaSearch = !enabledBetaSearch">
      Beta Search
    </div>
  </ng-container>

  <span menu-options *ngIf="authService.authenticated()">
    <!-- <app-feeds></app-feeds> -->
    <mat-divider class="feed-divider"></mat-divider>
    <button mat-menu-item [disabled]="authService.role !== 'Client'" (click)="changeUserDetails()">
      <mat-icon>edit</mat-icon>
      <span style="font-size: 14px">Change Profile Details</span>
    </button>
    <button mat-menu-item [disabled]="authService.role !== 'Client'" (click)="changeUserPassword()">
      <mat-icon>lock_reset</mat-icon>
      <span style="font-size: 14px">Change Password</span>
    </button>
    <mat-divider class="feed-divider"></mat-divider>
    <button mat-menu-item (click)="logout()">
      <mat-icon>power_settings_new</mat-icon>
      <span style="font-size: 14px">Log Out</span>
    </button>
  </span>
</styles-card-top-bar>

<shared-side-menu
  mode="slide"
  [mobileQuery]="mobileQuery"
  [appVersion]="appVersion"
  [ngClass]="[
    authService.authenticated() ? '' : 'sidebar-logged-out',
    hideSideNavText ? 'icon-menu' : 'full-menu'
  ]"
>
  <span page-content>
    <main>
      <div class="main-content-wrapper" [class.full-width]="pageOnly">
        <router-outlet #outlet="outlet"></router-outlet>
      </div>
    </main>
  </span>
</shared-side-menu>
